/* global window */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import throttle from 'lodash.throttle'

class ComponentInView extends Component {
  static propTypes = {
    /**
     * Override if you only want scroll or resize listeners
     */
    eventTriggers: PropTypes.arrayOf(PropTypes.string),
    /**
     * Custom class names
     */
    classNames: PropTypes.string,
    /**
     * Custom data-test values
     */
    'data-test': PropTypes.string,
    /**
     * Add to the difference of the bottom detection of the wrapped component
     */
    offsetBottom: PropTypes.number,
    /**
     * Add to the difference of the top detection of the wrapped component
     */
    offsetTop: PropTypes.number,
    /**
     * Custom throttle wait between refiring checks
     */
    throttleWait: PropTypes.number
  }

  static defaultProps = {
    eventTriggers: ['scroll', 'resize'],
    'data-test': 'component-in-view',
    offsetBottom: 0,
    offsetTop: 0,
    throttleWait: 100
  }

  constructor(props) {
    super(props)
    this.checkInView = this.checkInView.bind(this)
    this.elements = []
    this.current = []
  }

  componentDidMount() {
    const { elements } = this
    const { eventTriggers } = this.props
    elements.push(this.node)
    this.checkInView()
    eventTriggers.forEach((event) => {
      window.addEventListener(event, this.checkInView)
    })
  }

  componentWillUnmount() {
    const { eventTriggers } = this.props
    eventTriggers.forEach((event) => {
      window.removeEventListener(event, this.checkInView)
    })
  }

  checkInView() {
    const { onEnter, onLeave, offsetBottom, offsetTop, throttleWait } = this.props
    const isInView = (element) => {
      const clientRect = element.getBoundingClientRect()
      return clientRect.bottom > offsetTop && window.innerHeight - clientRect.top > offsetBottom
    }
    throttle(() => {
      this.elements.forEach((element) => {
        const index = this.current.indexOf(element)
        const entered = isInView(element) && !index > -1
        const exited = !isInView(element) && index > -1
        if (entered) {
          this.current.push(element)
          onEnter(element)
        }
        if (exited) {
          this.current.splice(index, 1)
          onLeave(element)
        }
      })
    }, throttleWait)()
  }

  render() {
    const { classNames, children, 'data-test': dataTest } = this.props
    return (
      <div
        className={classNames || ''}
        data-test={dataTest}
        ref={(node) => {
          this.node = node
        }}>
        {children}
      </div>
    )
  }
}

export default ComponentInView
